module.exports = __webpack_public_path__ + "d664063e.png";